import { render, staticRenderFns } from "./UpgradeInactiveModal.vue?vue&type=template&id=5b817ee3"
import script from "./UpgradeInactiveModal.vue?vue&type=script&lang=js"
export * from "./UpgradeInactiveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports